import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import Badge from '@material-ui/core/Badge';
import notification, {
  NotificationData,
} from '../../services/db/notifications/notification';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import { makeStyles, Popover, Tooltip } from '@material-ui/core';
import List from '@material-ui/core/List';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Scrollbar from '../Scrollbar';
import IntlMessages from '../../utility/IntlMessages';
import Hidden from '@material-ui/core/Hidden';
import clsx from 'clsx';
import { gql } from "@apollo/client";
import { Fonts } from '../../../shared/constants/AppEnums';
import { CremaTheme } from '../../../types/AppContextPropsType';
import { useGetNotfnListQuery, useUpdateAdminNotificationFlagMutation } from 'generated/graphql';
import { useHistory } from 'react-router-dom';
import getClient from 'service/ApolloClient';



const useStyles = makeStyles((theme: CremaTheme) => ({
  crPopover: {
    '& .MuiPopover-paper': {
      width: 260,
      [theme.breakpoints.up('sm')]: {
        width: 300,
      },
      [theme.breakpoints.up('xl')]: {
        width: 380,
      },
    },
    '& .scroll-submenu': {
      maxHeight: 200,
      [theme.breakpoints.up('xl')]: {
        maxHeight: 380,
      },
    },
  },
  btnPopover: {
    borderRadius: 0,
    width: '100%',
    textTransform: 'capitalize',
  },
  notiBtn: {
    justifyContent: 'flex-start',
    width: '100%',
    height: 56,
    fontSize: 16,
    borderRadius: 0,
    paddingLeft: '1rem',
    paddingRight: '1rem',
    color: theme.palette.grey[800],
    '&:hover, &:focus': {
      color: theme.palette.text.primary,
      backgroundColor: 'rgba(0, 0, 0, 0.08)',
    },
    [theme.breakpoints.up('sm')]: {
      height: 70,
    },
    [theme.breakpoints.up('md')]: {
      justifyContent: 'center',
      width: 'auto',
      borderLeft: 'solid 1px',
      borderLeftColor: theme.palette.grey[200],
      borderRight: 'solid 1px',
      borderRightColor: theme.palette.grey[200],
      color: theme.palette.grey[400],
      '&:hover, &:focus': {
        color: theme.palette.text.primary,
      },
    },
    [theme.breakpoints.up('lg')]: {
      paddingLeft: '1.5rem',
      paddingRight: '1.5rem',
    },
    [theme.breakpoints.up('xl')]: {
      paddingLeft: '2.5rem',
      paddingRight: '2.5rem',
    },
  },
  notiIcon: {
    fontSize: 22,
    color: theme.palette.text.secondary,
    [theme.breakpoints.up('xl')]: {
      fontSize: 30,
    },
  },
  list: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  badge: {
    marginRight: 8,
  },
}));

interface NotificationsProps { }

const Notifications: React.FC<NotificationsProps> = () => {
  const [
    anchorNotification,
    setAnchorNotification,
  ] = React.useState<HTMLButtonElement | null>(null);
  const onClickNotificationButton = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    setAnchorNotification(event.currentTarget);
  };
  const history = useHistory();
  const classes = useStyles();
  const [
      updateAdminNotificationFlagMutation
    ] = useUpdateAdminNotificationFlagMutation(); 
  const { data, loading, error, refetch } = useGetNotfnListQuery({
    variables: { isNotification: true}
  });

  const [notifiactionsData, setnotifiactionsData] = React.useState([]);
  const [dataLoaded, setdataLoaded] = React.useState(false);

  if (!dataLoaded) {
    if (data === undefined) return null;
    else 
    {
      let res: string = JSON.stringify(data);
      // console.log("notification before:- " + res);
      var notifiactionsData1: any = [];
      let notifiactionsDataList:any=[];
      notifiactionsData1 = JSON.parse(JSON.stringify(data?.AdminNotificationList));
      notifiactionsData1 = notifiactionsData1.filter(el => el?.isRead !== true );
      notifiactionsData1.forEach((data: any) => {
        notifiactionsDataList.push({
        id:data?.id,
        notificationMessage:data?.notificationMessage,
        notificationUrl:data?.notificationUrl,
        createdOn:data?.createdOn,
        createdOn1:new Date(data?.createdOn)
        })
      })
      notifiactionsDataList.sort(function(a:any,b:any){
        return (b.createdOn1) - (a.createdOn1);
      });
       setnotifiactionsData(notifiactionsDataList);   
       // console.log("notification before1:- " + notifiactionsData);
  }

    setdataLoaded(true);
  }
  const handleRedirectNotifi = async () => {
    let adminDetails = localStorage.getItem('AdminDetails') || '';
    const adminDetailsConfig = JSON.parse(adminDetails);
    let res = await updateAdminNotificationFlagMutation({
      variables: {
        id: adminDetailsConfig.id,
        isRead: true,
        isNotificationAll: true
      },
    });

    if(res){
      await getNotificationList(null);
    }
    window.location.href = "/notifications-communication"
  }

  const navigate = async (val) => {
    let res = await updateAdminNotificationFlagMutation({
          variables: {
            id: val?.id,
            isRead: true
          },
        });

        if(res){
          await getNotificationList(val);
        }
  }

  const getNotificationList = async (val?) => {
    let client = await getClient();
         
    client
     .query({
       query: gql`
         query {
           AdminNotificationList(isNotification: true) {
             id
             notificationMessage
             notificationUrl
             createdOn,
             isRead
           }
         }
       `,
       }).then((result) => {
       var notifiactionsData1: any = [];
       let notifiactionsDataList:any=[];
       notifiactionsData1 = JSON.parse(JSON.stringify(result.data?.AdminNotificationList));
       notifiactionsData1 = notifiactionsData1.filter(el => el?.isRead !== true );
       notifiactionsData1.forEach((data: any) => {
         notifiactionsDataList.push({
         id:data?.id,
         notificationMessage:data?.notificationMessage,
         notificationUrl:data?.notificationUrl,
         createdOn:data?.createdOn,
         createdOn1:new Date(data?.createdOn)
         })
       })
       notifiactionsDataList.sort(function(a:any,b:any){
         return (b.createdOn1) - (a.createdOn1);
       });
        setnotifiactionsData(notifiactionsDataList);
        if(val && val.notificationUrl!==''){
          history.push(val.notificationUrl);   
        }
        
     })
  }

  return (
    <>
      <Tooltip title={<IntlMessages id='header.tooltip.notifications' />}>
        <IconButton
          className={clsx(classes.notiBtn, 'notiBtn')}
          aria-label='show 17 new notifications'
          color='inherit'
          onClick={onClickNotificationButton}>
          <Badge
            className={classes.badge}
            badgeContent={notifiactionsData.length}
            color='secondary'>
            <NotificationsActiveIcon
              className={clsx(classes.notiIcon, 'notiIcon')}
            />
          </Badge>
          <Hidden mdUp>
            <Box
              ml={4}
              fontSize={16}
              fontFamily='Poppins'
              fontWeight={Fonts.REGULAR}
              component='span'>
              <IntlMessages id='common.notifications' />
            </Box>
          </Hidden>
        </IconButton>
      </Tooltip>
      <Popover
        anchorEl={anchorNotification}
        id='language-switcher'
        className={classes.crPopover}
        keepMounted
        open={Boolean(anchorNotification)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        onClose={() => setAnchorNotification(null)}>
        <Box>
          <Box px={5} py={3}>
            <Box component='h5' fontFamily='Poppins' fontSize={16}>
              <IntlMessages id='common.notifications' />{" "}<span className='numericTxt'>({notifiactionsData.length})</span>
            </Box>
          </Box>
          <Scrollbar className='scroll-submenu'>
            <List
              className={classes.list}
              onClick={() => {
                setAnchorNotification(null);
              }}>
             {notifiactionsData?.map((item: any, index) => (
                // <MessageItem key={item?.taskMessage} item={item} />
                <Box pl={{ xs: 4 }} pr = {{xs: 4}} pb={{xs: 2}} component='ul' color='text.secondary' key={index}   style={{marginLeft:'10px'}}>
                {/* <ul> */}
                    <li>
                      <span style={{ cursor:'pointer', color: 'blue', textDecoration:'none'}} onClick={ e => navigate(item)}> {item?.notificationMessage}</span>
                    </li>
                    {/* </ul> */}
                </Box>              
              ))}
            </List>
          </Scrollbar>
          <Box mt={2}>
            <Button
              className={classes.btnPopover}
              variant='contained'
              color='primary'
              onClick={handleRedirectNotifi}>
              <IntlMessages id='common.viewAll' />
            </Button>
          </Box>
        </Box>
      </Popover>
    </>
  );
};

export default Notifications;
